import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ComboService} from "../Services/combo.service";
import {Combo} from "./combo";
import {ComboDetalle} from "./comboDetalle";
import {Producto} from "../producto/producto";
import {ProductoService} from "../Services/producto.service";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {InventarioService} from "../Services/inventario.service";
import {Inventario} from "../inventario/inventario";

@Component({
  selector: 'app-combo',
  templateUrl: './combo.component.html',
  styleUrls: ['./combo.component.css']
})
export class ComboComponent implements OnInit {

  msgs: Message[] = [];
  formCombo : FormGroup;
  formDetalleCombo : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnNuevaDetalleCombo = true;
  btnCancelarDetalleCombo = true;
  btnGuardarDetalleCombo = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  CombosRegistrados:Combo[];
  ComboSeleccionado:Combo;
  tipoGuardado = '';
  panelDetalleCombo = false;
  DetallesRegistrados:ComboDetalle[];
  verComboDetalle = false;
  ProductosRegistrados:Producto[];
  TiendasRegistrados:Tienda[];
  verListaProductos = false;


  constructor(private servicioTienda:TiendaService,
              private servicioInventario : InventarioService,
              private servicioCombo:ComboService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesCombo();
    this.crearControlesDetalleCombo();
    this.Cancelar();
    this.CancelarDetalleCombo();
    this.listarCombos();
    this.listarTiendas();
  }

  crearControlesCombo(){
    this.formCombo = this.fb.group({
      nombre:['',Validators.required],
      codigoBarra:[''],
      tienda_id:['',Validators.required],
      }
    );

  }
  crearControlesDetalleCombo(){
    this.formDetalleCombo = this.fb.group({
      nombreProducto:[''],
      combo_id:[''],
      producto_id:['', Validators.required],
      cantidad:['', Validators.required]
      }
    );
  }
  nuevoCombo(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formCombo.enable();
    this.formCombo.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formCombo.reset();
    this.formCombo.disable();
    this.panelRequeridos = false;
    this.verComboDetalle = false;
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoCombo(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioCombo.putCombo(this.formCombo.value,this.ComboSeleccionado['Combo'].id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarCombos();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioCombo.addCombo(this.formCombo.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarCombos();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarCombos(){
    this.loading = true;
    this.servicioCombo.getCombo()
      .subscribe(
        rt => {
          this.CombosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarCombo(item:Combo){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formCombo.enable();
    this.panelRequeridos = true;
    this.ComboSeleccionado = item;
    this.ComboDetalle(item);
    this.tipoGuardado = 'editar';
    this.listarDetallesByCombo(item);
    this.listarProductos();
    this.verComboDetalle = true;
  }
  ComboDetalle(item:Combo):void {
    this.formCombo.patchValue({
      id:item.id,
      nombre:item.nombre,
      codigoBarra:item.codigoBarra,
      precio:item.precio,
      tienda_id:item.tienda_id,
    });
  }
  guardarNuevaDetalleCombo(){
    this.loading = true;
    this.formDetalleCombo.patchValue({
      combo_id:this.ComboSeleccionado.id,
    });
    console.log(this.formDetalleCombo.value);
    this.servicioCombo.asignarUsuario(this.formDetalleCombo.value)
      .subscribe(
        rt => {
          this.mensajes('success','Guardar',rt);
          this.listarDetallesByCombo(this.ComboSeleccionado);
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
          this.formDetalleCombo.reset();
        });
  }
  nuevaDetalleCombo(){
    this.btnNuevaDetalleCombo = false;
    this.btnGuardarDetalleCombo = true;
    this.btnCancelarDetalleCombo = true;
    this.formDetalleCombo.enable();
    this.formDetalleCombo.reset();
    this.panelDetalleCombo = true;
  }
  CancelarDetalleCombo(){
    this.btnGuardarDetalleCombo = false;
    this.btnNuevaDetalleCombo = true;
    this.btnCancelarDetalleCombo = false;
    this.formDetalleCombo.reset();
    this.formDetalleCombo.disable();
    this.panelDetalleCombo = false;
    this.verComboDetalle = false;
  }
  listarDetallesByCombo(item:Combo){
    this.loading = true;
    this.servicioCombo.getDetallesByCombo(item.id)
      .subscribe(
        rt => {
          this.DetallesRegistrados=rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        });

  }
  listarProductos(){
    this.loading = true;
    this.servicioInventario.getInventarioByTienda(this.ComboSeleccionado.tienda_id)
      .subscribe(
        rt => {
          this.ProductosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  VerProducto(){
    this.verListaProductos = true;
  }
  seleccionarProducto(item:any){
    this.formDetalleCombo.patchValue({
      nombreProducto:item.nombre,
      producto_id:item.producto_id
    });
    this.verListaProductos = false;
  }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/combo/combo.component.ts